import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useSharingObjectsState = createStateHook(
  AppStoreProvider,
  state => state.pages.sharingObjects
)
export const useNextSharingObjectsState = () =>
  createNextHook(AppStoreProvider, state => state.pages.sharingObjects)
